import { render, staticRenderFns } from "./FormOrientation.vue?vue&type=template&id=631a04d8&scoped=true"
import script from "./FormOrientation.vue?vue&type=script&lang=js"
export * from "./FormOrientation.vue?vue&type=script&lang=js"
import style0 from "./FormOrientation.vue?vue&type=style&index=0&id=631a04d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a04d8",
  null
  
)

export default component.exports